import { call, put, select } from 'redux-saga/effects';
import * as trackTime from '../../../../services/tracking-time';
import api from '../../../../services/api';
import * as Actions from './actions';

export function* documentosPendentes({ contrato, onSuccess, onError }){
    try{
        let client = yield call(api, "protocolo");
        let response = yield call(
            client.post,
            "consultasql/exec/protocolo-complemento-documentos-pendentes",
            { filter: {
                idContrato: contrato.IdContrato,
            }}
        );
        onSuccess({ ...contrato, documentos: response.data });

    }catch(e) {
        onError(`Erro ao buscar documentos pendentes: ${e.message}`);
    }
}

export function* searchRequest() {
    try {
        let protocolo_tipo = yield select(
            (x) => x.protocoloEnvio.protocolo_tipo
        );
        let filter_fields = yield select((x) => x.protocoloEnvio.filter_fields);

        let filter = {};

        for (const [key, value] of Object.entries(filter_fields)) {
            if (value !== "") filter[key] = value;
        }

        let body = {
            filter: filter,
        };

        let client = yield call(api, "protocolo");
        let response = yield call(
            client.post,
            `consulta/exec/${protocolo_tipo}`,
            body
        );

        var result = response.data;

        yield put(Actions.searchSuccess(result));
    } catch (error) {
        yield put(Actions.searchFailure());
    }
}

export function* searchProtocoloRequest({ param }) {
    try {
        let filter = {
            "protocolo.numero": param,
        };

        let body = {
            filter: filter,
        };

        let client = yield call(api, "protocolo");
        let response = yield call(
            client.post,
            `consulta/exec/protocolo_consulta`,
            body
        );

        var result = response.data;

        yield put(Actions.searchProtocoloSuccess(result));
    } catch (error) {
        yield put(Actions.searchFailure());
    }
}

export function* insertRequest() {
  try {
    const contratos = yield select((x) => x.protocoloEnvio.incluidos);
    const numero_envelope = yield select(
      (x) => x.protocoloEnvio.numero_envelope,
    );
    const protocolo_tipo = yield select(
      (x) => x.protocoloEnvio.protocolo_tipo,
    );
    const user = yield select((x) => x.protocoloEnvio.user);

    const now = new Date();
    const obj = { start_date: now, end_date: now };
    const timer = trackTime.get(protocolo_tipo);

    const payload = {
      numero_envelope,
      contratos,
      protocolo_tipo,
      nome_usuario: user ? user.name : 'Admin',
      internaluser: user.internaluser,
      track_time: { ...obj, ...timer },
    };

    const client = yield call(api, 'protocolo');
    const result = yield call(
      client.post,
      `protocolo/${payload.protocolo_tipo}`,
      payload,
    );

    if (result.response && result.response.status === 400) {
      yield put(Actions.requestFailure(result.response));
    } else {
      yield put(Actions.saveSuccess(result.data));
    }
  } catch (error) {
    yield put(Actions.requestFailure(error.response));
  }
}

export function* selectsRequest() {
  try {
    const client = yield call(api, 'bfconsig');
    const bodySelect = {
      limit: 10000,
    };
    const result_produto = yield call(
      client.post,
      'consulta/exec/produtos',
      bodySelect,
    );
    const result_loja = yield call(
      client.post,
      'consulta/exec/lojas',
      bodySelect,
    );
    const result_promotora = yield call(
      client.post,
      'consulta/exec/promotoras',
      bodySelect,
    );
    const result_convenio = yield call(
      client.post,
      'consulta/exec/convenios',
      bodySelect,
    );

    const selects = {};
    selects.produtos = result_produto.data;
    selects.lojas = result_loja.data;
    selects.promotoras = result_promotora.data;
    selects.convenios = result_convenio.data;

    yield put(Actions.selectsSuccess(selects));
  } catch (error) {
    yield put(Actions.requestFailure());
  }
}

export function* listaPromotorasRequest({ payload }) {
    const getHierarquiaCadastroFilter = (hierarquia) => {
        if (
            !!hierarquia.master &&
            !!hierarquia.master.substabelecida &&
            !!hierarquia.master.substabelecida.filial
        ) {
            return hierarquia.master.substabelecida.filial.cod;
        }
        if (!!hierarquia.master && !!hierarquia.master.filial) {
            return hierarquia.master.filial.cod;
        }
        if (!!hierarquia.master && !!hierarquia.master.substabelecida) {
            return hierarquia.master.substabelecida.cod;
        }
        if (!!hierarquia.master) {
            return hierarquia.master.cod;
        }
    };
    try {
        const client = yield call(api, "bfconsig");

        let filter;
        if (
            !!payload &&
            !!payload.hierarquiaCadastro &&
            !!payload.hierarquiaCadastro.length
        ) {
            filter = {
                "lista.codigo": getHierarquiaCadastroFilter(
                    payload.hierarquiaCadastro[0]
                ),
            };
        }

        const params = { limit: 10000, filter };
        const { data } = yield call(
            client.post,
            "consulta/exec/promotoras",
            params
        );

        yield put(Actions.listaPromotorasSuccess(data));
    } catch (error) {
        yield put(Actions.requestFailure());
    }
}

export function* listaLojasRequest({ payload }) {
    const getHierarquiaCadastroFilter = (hierarquia) => {
        let filter = {};
        if (!hierarquia.master) return filter;
        filter["lista.hierarquiaCadastro.master.cod"] = hierarquia.master.cod;

        if (!!hierarquia.master.filial) {
            filter["lista.hierarquiaCadastro.master.filial.cod"] =
                hierarquia.master.filial.cod;
        }

        if (!hierarquia.master.substabelecida) return filter;
        filter["lista.hierarquiaCadastro.master.substabelecida.cod"] =
            hierarquia.master.substabelecida.cod;

        if (!hierarquia.master.substabelecida.filial) return filter;
        filter["lista.hierarquiaCadastro.master.substabelecida.filial.cod"] =
            hierarquia.master.substabelecida.filial.cod;

        return filter;
    };

    try {
        const client = yield call(api, "bfconsig");

        let filter;
        if (
            !!payload &&
            !!payload.hierarquiaCadastro &&
            !!payload.hierarquiaCadastro.length
        ) {
            filter = getHierarquiaCadastroFilter(payload.hierarquiaCadastro[0]);
        }

        const params = { limit: 10000, filter };
        const { data } = yield call(client.post, "consulta/exec/lojas", params);

        yield put(Actions.listaLojasSuccess(data));
    } catch (error) {
        yield put(Actions.requestFailure());
    }
}

export function* listaConveniosRequest({ payload }) {
    try {
        const client = yield call(api, "bfconsig");

        let filter;
        if (!!payload && !!payload.codProduto) {
            filter = { "lista.produtos.codigo": payload.codProduto };
        }

        const params = { limit: 10000, filter };
        const { data } = yield call(
            client.post,
            "consulta/exec/convenios",
            params
        );

        yield put(Actions.listaConveniosSuccess(data));
    } catch (error) {
        yield put(Actions.requestFailure());
    }
}

export function* listaProdutosRequest(params) {
    try {
        const client = yield call(api, "bfconsig");
        const bodySelect = { limit: 10000 };
        const { data } = yield call(
            client.post,
            "consulta/exec/produtos",
            bodySelect
        );

        yield put(Actions.listaProdutosSuccess(data));
    } catch (error) {
        yield put(Actions.requestFailure());
    }
}

export function* protocoloMassaValidar({ payload: { type, params } }) {
  try {
    const client = yield call(api, 'protocolo');
    const { data } = yield call(
      client.get,
      `/protocolo/massa/${type.replace('protocolo_', '')}`,
      { params },
    );

    yield put(Actions.protocoloMassaSuccess(data));
  } catch (error) {
    yield put(Actions.protocoloMassaFailure());
  }
}
